/**
 * @description 高亮行列
 */

import Store from "../store";

class HighlightCellCtrl {
    constructor() {}

    /**
     * 获取当前选区 - 支持多选区同时高亮 "row": [5,7],"column": [3,5],
     */
    getSelectedRanges() {
        return Store.luckysheet_select_save;
    }

    /**
     * @description 判断当前单元格是否处于高亮选区中 - 只要r 在 或者 c 在选区中即可高亮
     */
    needHighlight(r, c) {
        const selectedRanges = this.getSelectedRanges();
        return selectedRanges.some((range) => {
            // 这里取一下边界
            const rs = range.row[0];
            const re = range.row[1];
            const cs = range.column[0];
            const ce = range.column[1];
            // 这里判断一下是否在选区中
            return (rs <= r && r <= re) || (cs <= c && c <= ce);
        });
    }

    /**
     * @description 判断当前单元格是否在选区内部 - 在选区内部的话，颜色不一样(目前暂定与其他高亮行列颜色一致)
     */
    isSelectedCellInRange(r, c) {
        const selectedRanges = this.getSelectedRanges();
        return selectedRanges.some((range) => {
            // 这里取一下边界
            const rs = range.row[0];
            const re = range.row[1];
            const cs = range.column[0];
            const ce = range.column[1];
            // 这里判断一下是否在选区内部
            return rs <= r && r <= re && cs <= c && c <= ce;
        });
    }

    /**
     * @description 处理颜色
     */
    /**
     * 解析颜色输入，支持 hex 字符串、rgb(r,g,b)/rgba(r,g,b,a) 字符串和 [r,g,b] 数组
     * @param {string|[number,number,number]} color - hex 颜色字符串 (如 "#ff0000")、rgb/rgba 字符串 (如 "rgb(255,0,0)" 或 "rgba(255,0,0,0.5)") 或 RGB 数组
     * @returns {[number,number,number]} RGB 数组
     */
    parseColorInput(color) {
        if (Array.isArray(color)) {
            return color;
        }
        if (color.includes("rgb")) {
            const rgb = color
                .replace(/rgba?\(|\)/g, "")
                .split(",")
                .slice(0, 3)
                .map((v) => parseInt(v.trim()));
            return rgb;
        }
        let hex = color.replace(/^#/, "");
        if (hex.length === 3) {
            hex = hex
                .split("")
                .map((c) => c + c)
                .join("");
        }
        const result = [];
        for (let i = 0; i < 3; i++) {
            result.push(parseInt(hex.substr(i * 2, 2), 16));
        }
        return result;
    }

    /**
     * @description 对传入的 rgb 进行颜色转换
     * @param {Array} rgb - rgb 数组
     * @returns {String} 'rgb(r,g,b)'
     */
    convertRgbToColor(rgb) {
        return `rgb(${rgb.join(",")})`;
    }

    /**
     * 颜色叠加函数，模拟 Excel 高亮行列效果
     * @param {string|[number,number,number]} c1 - 原始颜色 (hex 字符串或 RGB 数组)
     * @param {string|[number,number,number]} c2 - 高亮颜色 (hex 字符串或 RGB 数组)
     * @param {number} alpha - 高亮层不透明度，默认 0.34
     * @returns {string} 叠加后的颜色 RGB
     */
    blendColors(c1, c2, alpha = 0.34) {
        if (!c1) return c2;
        const rgb1 = this.parseColorInput(c1);
        const rgb2 = this.parseColorInput(c2);
        const rgb = rgb1.map((v, i) => {
            const mixed = Math.round(v * (1 - alpha) + rgb2[i] * alpha);
            return Math.max(0, Math.min(255, mixed));
        });
        return this.convertRgbToColor(rgb);
    }
}

export const highlightCellCtrl = new HighlightCellCtrl();
